import { render, staticRenderFns } from "./ColdChain.vue?vue&type=template&id=185b598e"
import script from "./ColdChain.vue?vue&type=script&lang=js"
export * from "./ColdChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports